import { FormattedMessage, useIntl } from 'react-intl';
import { Tooltip, Icon } from '@ets/design-system';
import dayjs from 'dayjs';

type StatusCellProps = {
  object: Objekt;
};

const StatusCell = ({ object }: StatusCellProps) => {
  const intl = useIntl();

  const isExpired = () => {
    return object.expiration.active && dayjs(object.expiration.expiration).isBefore(dayjs());
  };

  if (isExpired()) {
    return (
      <>
        <div style={{ marginRight: '1rem' }}>
          <FormattedMessage id="settings.publicLink.expired" />
        </div>
        <Tooltip
          content={intl.formatMessage({
            id: 'settings.publicLink.tooltips.expiredTooltip',
          })}
          testId={`row-${object.id}-status-expired`}
        >
          <div style={{ display: 'flex' }}>
            <Icon
              icon="circle-info"
              size="2"
              testId={`row-${object.id}-status-expired`}
              color="primary"
            />
          </div>
        </Tooltip>
      </>
    );
  }
  return (
    <>
      <div>
        <FormattedMessage id={object.expiration.active ? 'global.active' : 'global.inactive'} />
      </div>
    </>
  );
};

export default StatusCell;
